import Vue from 'vue'
import Alert from '@/services/Alert.js'

function initialState() {
  return {
    alerts: {},
    device: 'all',
    totalNewAlert: 0,
    totalAckAlert: 0,
    totalResolvedAlert: 0
  }
}

let state = initialState()

const mutations = {
  SET_ALERT(state, payload) {
    Vue.set(state, 'alerts', payload ? payload.data : {})
    // state.alerts = payload
  },
  SET_TOTAL_NEW_ALERTS(state, payload) {
    state.totalNewAlert = payload
  },
  SET_TOTAL_ACK_ALERTS(state, payload) {
    state.totalAckAlert = payload
  },
  SET_TOTAL_RESOLVED_ALERTS(state, payload) {
    state.totalResolvedAlert = payload
  },
  APPEND_NEW_ALERT(state, alert) {
    Object.keys(Object.values(alert)[0]).forEach(key => {
      if (!state.alerts[Object.keys(alert)[0]]) {
        state.alerts[Object.keys(alert)[0]] = {}
      }
      Vue.set(state.alerts[Object.keys(alert)[0]], key, Object.values(alert)[0][key])
    })
  },
  SET_DEVICE(state, device) {
    state.device = device
  },
  RESET_STATE(state) {
    const initial = initialState()
    Object.assign(state, initial)
  }
}

const actions = {
  fetchAlert({ commit }, param) {
    commit('SET_PROGRESS_BAR', true, { root: true })
    let obj = {
      page: param.page,
      itemPerPage: param.itemPerPage
    }
    const info = Buffer.from(
      JSON.stringify(obj)
    ).toString('base64')
    Alert.getAlertListV2(
      param.plantId,
      param.dateFrom,
      param.dateTo,
      param.status,
      param.device,
      param.severity,
      info
    ).then(response => {
      if (response.status === 200) {
        const data = response.data.message
        const count = data && data.metadata[0] && data.metadata[0].count ? data.metadata[0].count : 0
        if (count) {
          switch (Object.values(data.data)[0].status) {
            case 'new':
              commit('SET_TOTAL_NEW_ALERTS', count)
              break
            case 'resolved':
              commit('SET_TOTAL_RESOLVED_ALERTS', count)
              break
            case 'acknowledge':
              commit('SET_TOTAL_ACK_ALERTS', count)
              break
          }
        }

        commit('SET_ALERT', data)
        commit('SET_PROGRESS_BAR', false, { root: true })
      } else {
        // Handle error
        commit('SET_PROGRESS_BAR', false, { root: true })
        console.log(response)
      }
    })
  },
  downloadAlert({ commit }, param) {
    Alert.downloadAlertListV2(
      param.plantId,
      param.plantName,
      param.dateFrom,
      param.dateTo,
      param.status,
      param.device,
      param.severity
    )
  },
  updateAlert({ commit }, payload) {
    return Alert.updateStatusV2(payload)
  },
  appendNewAlert({ commit }, alert) {
    commit('APPEND_NEW_ALERT', alert)
  },
  setDevice({ commit }, device) {
    commit('SET_DEVICE', device)
  },
  clear({ commit }) {
    commit('RESET_STATE')
  }
}

const getters = {
  getAlerts: state => {
    return state.alerts
  },
  getTotalAlert: (state, getters) => {
    let alert = Object.values(getters.getAlerts)

    if (alert.length > 0) {
      switch (alert[0].status) {
        case 'new':
          return state.totalNewAlert
        case 'resolved':
          return state.totalResolvedAlert
        case 'acknowledge':
          return state.totalAckAlert
      }
    }
    return 0
  },
  isLoading: state => {
    return state.isLoading
  },
  device: state => {
    return state.device
  },
  activeCount: (state, getters) => {
    return state.totalNewAlert
  },
  ackCount: (state, getters) => {
    return state.totalAckAlert
  },
  resolvedCount: (state, getters) => {
    return state.totalResolvedAlert
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
